import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import { translate } from "react-i18next";
import mapObjIndexed from "ramda/src/mapObjIndexed";
import values from "ramda/src/values";
import compose from "ramda/src/compose";
import { func } from "prop-types";

import {
  Form,
  RadioButton,
  Button,
  FloatLabelInput,
  FloatLabelTextArea,
  FloatLabelSelect,
} from "shared/components";
import Loader from "../../../../components/Loading";
import styles from "../../styles.css";
import { asyncValidate, shouldAsyncValidate } from "redux-form-yup";
import * as Yup from "yup";
import * as Mask from "../../../../services/utils/mask";
import { createCommonIncident } from "../../../../services/state/actions";

let optionsPabx = [
  {
    label: "Sim",
    checked: true,
    value: true,
  },
  {
    label: "Não",
    checked: true,
    value: false,
  },
];

let optionsRamal = [
  {
    label: "Sim",
    checked: true,
    value: true,
  },
  {
    label: "Não",
    checked: true,
    value: false,
  },
];

class UnavailableForm extends Component {
  state = {
    isOpenProducts: this.props.isOpen,
    products: null,
    circuit: null,
  };

  onSubmit = (form) => {
    const { t, reason, createCommonIncident, onNextStep, onReset } = this.props;

    const checklist = {
      data: { ...form, reason },
      labels: {
        key: t("MSG_0281"),
        contactPhone: t("MSG_0206"),
        timeSlot: t("MSG_0205"),
        description: t("MSG_0202"),
        ramal: t("MSG_0282"),
        pabx: t("MSG_0283"),
        calledInternal: t("MSG_0203"),
      },
    };

    return createCommonIncident(checklist, onNextStep, onReset);
  };

  changeRadioRamal = (e) => {
    optionsRamal.map((item) => {
      if (item.value === e.target.value) {
        item.checked = true;
        return this.setState({
          userNotificationMethod: e.target.value,
        });
      }
      return (item.checked = true);
    });
  };

  changeRadioPabx = (e) => {
    optionsPabx.map((item) => {
      if (item.value === e.target.value) {
        item.checked = true;
        return this.setState({
          userNotificationMethod: e.target.value,
        });
      }
      return (item.checked = true);
    });
  };

  renderRadioField(field) {
    const { id, name, text } = field;

    return (
      <div className={styles.radioRoot}>
        <span className={styles.titleRadio}>{text}</span>
        <RadioButton
          {...field.input}
          name={name}
          id={id}
          options={field.options}
          onChange={field.onchange}
        />
      </div>
    );
  }

  renderInputField(field) {
    const {
      meta: { touched, error, invalid },
    } = field;

    return (
      <FloatLabelInput
        {...field.input}
        id={field.id}
        type={field.type ? field.type : "text"}
        label={field.label}
        maxLength={field.id === "contactPhone" ? "15" : ""}
        invalid={touched && invalid}
        error={error}
        value={field.input.value ? field.input.value : ""}
      />
    );
  }

  renderSelectField(field) {
    const {
      meta: { touched, error, invalid },
    } = field;

    const options = values(
      mapObjIndexed((label, value) => ({ label, value }), field.options)
    );

    return (
      <FloatLabelSelect
        id={field.id}
        options={options}
        label={field.label}
        invalid={touched && invalid}
        error={error}
        defaultOption
        {...field.input}
      />
    );
  }

  renderTextAreaField(field) {
    return (
      <FloatLabelTextArea
        id={field.id}
        name={field.name}
        noResize
        label={field.label}
        preset="modalTextArea"
        onChange={field.input.onChange}
        value={field.input.value ? field.input.value : ""}
      />
    );
  }

  render() {
    const { t, handleSubmit, submitting, onPreviousStep } = this.props;

    return (
      <Fragment>
        <span>{t("MSG_0211")}</span>
        <Form onSubmit={handleSubmit(this.onSubmit)}>
          <Field
            id="keyVoice"
            label={t("MSG_0281")}
            name="keyVoice"
            component={this.renderInputField}
            format={Mask.phone}
            normalize={Mask.algarPhone}
          />

          <Field
            id="description"
            label={t("MSG_0202")}
            maxLength={500}
            name="description"
            component={this.renderTextAreaField}
          />

          <Field
            id="ramal"
            name="ramal"
            component={this.renderRadioField}
            onchange={this.changeRadioRamal}
            options={optionsRamal}
            text={t("MSG_0282")}
          />

          <Field
            id="pabx"
            name="pabx"
            component={this.renderRadioField}
            onchange={this.changeRadioPabx}
            options={optionsPabx}
            text={t("MSG_0283")}
          />

          <Field
            id="calledInternal"
            type="text"
            label={t("MSG_0203")}
            name="calledInternal"
            component={this.renderInputField}
          />

          <Field
            id="contactPhone"
            type="text"
            label={t("MSG_0206")}
            name="contactPhone"
            component={this.renderInputField}
            format={Mask.phone}
            normalize={Mask.algarPhone}
            maxLength={11}
          />

          <Field
            id="timeSlot"
            type="text"
            label={t("MSG_0205")}
            name="timeSlot"
            component={this.renderInputField}
            format={Mask.timeRange}
            normalize={Mask.timeRange}
          />

          <div className={styles.actions}>
            <Button onClick={onPreviousStep} relevance="low">
              {t("MSG_0292")}
            </Button>

            <Button type="submit" relevance="normal" callToAction>
              {t("MSG_0007")}
            </Button>
          </div>
        </Form>

        <Loader isOpen={submitting} />
      </Fragment>
    );
  }
}

function createValidationSchema() {
  return Yup.object().shape({
    keyVoice: Yup.string().required("Campo obrigatório"),

    calledInternal: Yup.string().required("Campo obrigatório"),

    timeSlot: Yup.string().required("Campo obrigatório"),

    contactPhone: Yup.string()
      .required("Campo obrigatório")
      .matches(/^0\d{1,11}$/, {
        message: "Número de telefone inválido",
        excludeEmptyString: true,
      }),
  });
}

UnavailableForm.propTypes = {
  onPreviousStep: func.isRequired,
  onNextStep: func.isRequired,
};

const reduxFormConfig = {
  form: "UnavailableForm",
  asyncValidate: asyncValidate(createValidationSchema()),
  shouldAsyncValidate,
};

const mapStateToProps = ({ repair }) => ({
  error: repair.error,
});

const enhance = compose(
  translate(),
  connect(mapStateToProps, { createCommonIncident }),
  reduxForm(reduxFormConfig)
);

export default enhance(UnavailableForm);



// WEBPACK FOOTER //
// ./src/components/RepairWizard/components/ModalTotalVoice/UnavailableForm.js